const REGION_KEY = 'shipmnts_region';

const COUNTRY_TO_REGION = {
  IN: 'in',
  AE: 'uae', SA: 'uae', KW: 'uae', QA: 'uae', BH: 'uae', OM: 'uae',
  US: 'us',
};

// On prod, CloudFront Function handles geo-redirects server-side before HTML
// is served. detectRegion() is only reached by global/unknown-region users on
// prod, and by all users in local dev (no CloudFront).
export async function detectRegion() {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') {
    return 'global';
  }

  const cached = sessionStorage.getItem(REGION_KEY);
  if (cached) return cached;

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000);
    const res = await fetch('https://ipapi.co/json/', { signal: controller.signal });
    clearTimeout(timeoutId);
    const { country_code } = await res.json();
    const region = COUNTRY_TO_REGION[country_code] || 'global';
    sessionStorage.setItem(REGION_KEY, region);
    return region;
  } catch {
    return 'global';
  }
}
